import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './Link.css';

interface ILinkProps {
  url: string;
  text: string;
  size?: 'XS' | 'M';
  fontweight?: '400' | '700';
  onClick?(): void;
  id?: string;
}

export function Link({ id, url, text, size = 'XS', fontweight = '400', onClick }: ILinkProps) {
  return (
    <a
      id={id}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={clsx(styles['link'], {
        [styles['link--m']]: size === 'M',
        [styles['link--fontweight400']]: fontweight === '400',
        [styles['link--fontweight700']]: fontweight === '700',
      })}
      onClick={onClick}
    >
      {text}
    </a>
  );
}
